import React, { FC } from 'react';

import { LocalizedAttribute } from '~/core/types';
import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { PanelBroadcast } from '../../../../../../types';

import { OtherCountriesButton, OtherCountriesDescription, OtherCountriesDescriptionButtonWrapper } from './styles';

type OtherCountriesPanelProps = {
    broadcast: PanelBroadcast;
    description?: LocalizedAttribute;
};

const OtherCountriesPanel: FC<OtherCountriesPanelProps> = ({ broadcast, description }) => (
    <OtherCountriesDescriptionButtonWrapper>
        {description && (
            <OtherCountriesDescription>{parseValueFromLocalizedAttribute(description)}</OtherCountriesDescription>
        )}
        <a href={broadcast.weblink} target="_blank">
            <OtherCountriesButton>{parseValueFromLocalizedAttribute(broadcast.title)}</OtherCountriesButton>
        </a>
    </OtherCountriesDescriptionButtonWrapper>
);

export default OtherCountriesPanel;
